import script from "./TimeChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeChips.vue?vue&type=script&setup=true&lang=ts"

import "./TimeChips.vue?vue&type=style&index=0&id=20cd57df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20cd57df"]])

export default __exports__